var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Redirecting...")]),_c('p',[_vm._v(" If you are not redirected, please "),_c('a',{attrs:{"href":_vm.redirectUrl}},[_vm._v("click here")]),_vm._v(". ")])])}
var staticRenderFns = []

export { render, staticRenderFns }